import { Dialog } from "@mui/material";
import { ParentCloseBtn, FadeTransition } from "common/elements";

export const ChatImageViewer = ({ url, onClose }: { url: string; onClose: () => void }) => {
  return (
    <Dialog
      fullScreen
      open={true}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div className="relative">
          <ParentCloseBtn close={onClose} />
          <img src={url} alt="" className="max-w-[80vw] max-h-[80vh] object-contain" />
        </div>
      </div>
    </Dialog>
  );
};
